// Employee notifications - see PCS.Domain/Models/EmployeeNotificationModels.cs and
// Plantovita.WebUI/docs/notifications-spec.md.

// One notification in the signed-in user's inbox. `id` is their recipient row.
export interface Notification {
    id: string;
    notificationId: string;
    senderName: string;
    message: string;
    link?: string | null;
    createdUtc: string;
    read: boolean;
    // The message this one replies to, if it's a reply.
    replyToMessage?: string | null;
}

export interface NotificationInbox {
    items: Notification[];
    unreadCount: number;
    total: number;
}

export interface SentNotificationRecipient {
    userId: string;
    name: string;
    readUtc?: string | null;
}

export interface SentNotification {
    id: string;
    message: string;
    link?: string | null;
    createdUtc: string;
    sentToWholeLab: boolean;
    replyToMessage?: string | null;
    recipients: SentNotificationRecipient[];
}

export interface SentNotificationPage {
    items: SentNotification[];
    total: number;
}

export interface NotificationColleague {
    userId: string;
    name: string;
    surname: string;
    email: string;
    // True for employees of the lab being addressed; false for Dankospark support staff from elsewhere.
    inLab: boolean;
}

// A lab a notification can be addressed to. Dankospark staff get every lab with employees.
export interface NotificationLab {
    labId: string;
    labName: string;
    isMine: boolean;
}

export interface SendNotification {
    // Only Dankospark staff choose the lab; the server ignores it for everyone else.
    labId?: string | null;
    recipientUserIds: string[];
    wholeLab: boolean;
    message: string;
    link?: string | null;
}

export interface SendNotificationResult {
    id: string;
    recipientCount: number;
}

// Must match EmployeeNotificationRepository.MaxMessageLength / MaxLinkLength.
export const NOTIFICATION_MESSAGE_MAX_LENGTH = 1000;
export const NOTIFICATION_LINK_MAX_LENGTH = 500;

// Lab roles that can send notifications (the server checks the user's lab, not these). Dankospark
// support staff can send too - see NotificationsService.canSend.
export const NOTIFICATION_SENDER_ROLES = ['Lab', 'LabAdmin', 'LabSysAdmin'];

// "Jane van Wyk" -> "JV", for the avatar circle next to a notification.
export function senderInitials(name: string): string {
    return (name ?? '')
        .split(' ')
        .filter(Boolean)
        .slice(0, 2)
        .map((part) => part[0].toUpperCase())
        .join('');
}
